module.exports = __webpack_public_path__ + "media/images/landing__eventPrize__prize2-14fe5428edb138589b4839d3f41b2f82.jpg";